interface IGetEtazhiBlackFridayUriParams {
  queryString?: string;
  jsonQueryString?: string;
}

export const getEtazhiBlackFridayUri = (params: IGetEtazhiBlackFridayUriParams) => {
  const { queryString = '', jsonQueryString = '' } = params;
  const urlSearchParams = new URLSearchParams(queryString + jsonQueryString);

  const newQuery = urlSearchParams.toString();

  return '/cat.php?' + newQuery;
};
